import { AuthConstants as Constants } from '../types'

const accessToken = process.env.REACT_APP_ACCESS_TOKEN
var token = localStorage.getItem(accessToken)

const initialState = {
    user: {},
    loggedIn: false,
    token: token,
    stats: [],
    statsRange: null
};

export function authReducer(state = initialState, action) {
    switch (action.type) {  
        case Constants.LOGIN:
            return {
                ...state,
                loggedIn: true,
                token: action?.payload?.token || token,
                user: action.payload.user,
            };

        case Constants.STATS:
            return {
                ...state,
                stats: action?.payload?.stats || [],
                // `range` reflects the window the backend actually applied,
                // which may differ from the request (out-of-bounds ranges
                // silently reset to the current calendar month).
                statsRange: action?.payload?.range || null
            };
            
        case Constants.REFRESH_TOKEN:
            return {
                ...state,
                token: action.payload?.token || null
            }

        case Constants.REFRESH_TOKEN_FAILED:
            return {
                ...state,
                user: null,
                token: null
            }   

        case Constants.SETPROFILE:
            return{
                ...state,
                user: action.payload.user,
            };
       
        case Constants.LOGOUT:
            return{
                ...state,
                loggedIn: false,
                token: null,
                user: {},
            };
                   
        case Constants.FAILED:
            return{
                ...state
            }
        case Constants.CLEAR:
        default:
            return state
    }
}